var Axios = require("axios");

function TimumApi() {
    var configure = function (opts) {
        this.timeout = window.location.hostname === "localhost" ? 90000 : 30000;

        this.axios = Axios.create({
            baseURL: opts.baseUrl || "https://www.timum.de",
            timeout: this.timeout
        });
        window.TimumApi = this;

        this.providerId = opts.providerId;
        this.resourceId = opts.resourceId;
    };

    var getTimeslots = function (args) {
        return this.axios({
            url: "/rest/1/resources/" + this.resourceId + "/upcoming_bookables",
            method: "get",
            params: args,
            headers: {
                Accept: "*/*",
                "Access-Control-Allow-Headers":
                    "Access-Control-Allow-Headers, Origin, X-Requested-With, Content-Type, Accept, Authorization, X-Auth-Token, X-SIGNED-TIMUM-CLIENT, auth2"
            }
        });
    };

    var getProducts = function () {
        return this.axios({
            url: "/rest/1/resources/" + this.resourceId + "/active_products",
            method: "get",
            headers: {
                Accept: "*/*",
                "Access-Control-Allow-Headers":
                    "Access-Control-Allow-Headers, Origin, X-Requested-With, Content-Type, Accept, Authorization, X-Auth-Token, X-SIGNED-TIMUM-CLIENT, auth2"
            }
        });
    };

    var createAppointmentWithConsumer = function (args, data) {
        return this.axios({
            method: "post",
            url: "/rest/1/resources/" + this.resourceId + "/create_appointment_with_consumer",
            params: args,
            data: data,
            headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
                "Access-Control-Allow-Headers":
                    "Access-Control-Allow-Headers, Origin, X-Requested-With, Content-Type, Accept, Authorization, X-Auth-Token, X-SIGNED-TIMUM-CLIENT, auth2"
            }
        });
    };

    return {
        getTimeslots: getTimeslots,
        getProducts: getProducts,
        createAppointmentWithConsumer: createAppointmentWithConsumer,
        configure: configure
    };
}

module.exports = TimumApi;
